module.exports = __webpack_public_path__ + "img/creep_dire.01c8f31d.png";